import React from "react";

import SermonItem from "./sermon-item";
import { useAudioPlayer } from "../../context/audio-player-context";

type Props = {
  sermons: Sermons;
  isLoading: boolean;
};

const SermonsSlider: React.FC<Props> = props => {
  const sermons = props.sermons || [];
  const { setCurrentSong, setSongs } = useAudioPlayer();

  const playSermon = (sermon: Sermon, index: number) => {
    if (sermon.type === "Audio") {
      const songs = sermons.map(sermon => (({ ...sermon } as unknown) as Song));

      setCurrentSong((sermon as unknown) as Song);
      setSongs(songs, index);
    }
  };

  return (
    <div className="flex space-x-3 overflow-x-auto flex-nowrap scrolling-wrapper">
      <div className="flex-shrink-0 w-px"></div>

      {sermons.map((sermon, index) => (
        <div className="flex-grow-0 flex-shrink-0 w-28 sm:w-32" key={sermon.id}>
          <SermonItem sermon={sermon} play={() => playSermon(sermon, index)} />
        </div>
      ))}

      {props.isLoading &&
        Array.from(Array(10).keys()).map(id => (
          <div className="flex-shrink-0 w-28 sm:w-32" key={id}>
            <div className="animate-pulse">
              <div className="w-full bg-gray-300 h-28 sm:h-32 rounded-xl" />

              <div className="px-2 py-2">
                <p className="h-3 pr-4 bg-gray-400 rounded-lg" />
                <p className="h-2 mt-2 bg-gray-400 rounded-lg" />
              </div>
            </div>
          </div>
        ))}

      <div className="flex-shrink-0 w-px"></div>
    </div>
  );
};

export default SermonsSlider;
